import React, { Component } from "react";
import { Provider } from "react-redux";
import { createStore, applyMiddleware } from "redux";
import { thunk } from "redux-thunk";

import SubscriberSearchBar from "./subscriber_search_bar.jsx";
import ResultSection from "./result_section.jsx";
import rootReducer from "../../../../reducers/subscriber_search";

export default class SubscriberSearchContainer extends Component {
  constructor(props) {
    super(props);

    window.onpopstate = () => {
      location.reload(true);
    };

    this.store = createStore(
      rootReducer,
      {
        organizationID: props.organizationID,
        mailingLists: props.mailingLists,
        query: props.query,
        subscribersFound: [],
        suppressionFound: [],
        loading: false,
        activeQuery: props.query || "",
        mailingListID: props.mailingListID ? parseInt(props.mailingListID) : 0,
        error: null,
        allOrganizations: props.allOrganizations,
        showAllOrganizationsOption: props.showAllOrganizationsOption,
      },
      applyMiddleware(thunk),
    );
  }

  render() {
    return (
      <Provider store={this.store}>
        <div className="subscriber-search-container">
          <div className="unsticky-header-container">
            <header className="unsticky-header">
              <div className="layout-wrapper-985">
                <div className="unsticky-header-inner">
                  <h1>{I18n.t("phrases.search_subscribers")}</h1>
                </div>
              </div>
            </header>
          </div>

          <div className="layout-wrapper-985">
            <SubscriberSearchBar
              mailingLists={this.props.mailingLists}
              initialQuery={this.props.query}
            />

            <ResultSection />
          </div>
        </div>
      </Provider>
    );
  }
}
